import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@nuxtjs/composition-api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  JSONObject: any;
};

/** This is the model we would use anytime we are filling out an accordion panel. */
export type AccordionPanel = {
  __typename?: 'AccordionPanel';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<AccordionPanelData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type AccordionPanelData = {
  __typename?: 'AccordionPanelData';
  newField0?: Maybe<Scalars['JSON']>;
};

/** This is the writer of any blog content. */
export type Author = {
  __typename?: 'Author';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<AuthorData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type AuthorData = {
  __typename?: 'AuthorData';
  bio?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** CMS model for blog */
export type Blog = {
  __typename?: 'Blog';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<BlogData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type BlogData = {
  __typename?: 'BlogData';
  author?: Maybe<Scalars['JSON']>;
  blurb?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  body2?: Maybe<Scalars['String']>;
  body3?: Maybe<Scalars['String']>;
  body4?: Maybe<Scalars['String']>;
  coverImage?: Maybe<Scalars['String']>;
  posterImage?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
};

/** These are the different categories of blogs */
export type Categories = {
  __typename?: 'Categories';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<CategoriesData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type CategoriesData = {
  __typename?: 'CategoriesData';
  name?: Maybe<Scalars['String']>;
};

/** Components */
export type Component = {
  __typename?: 'Component';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<ComponentData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type ComponentData = {
  __typename?: 'ComponentData';
  blocks?: Maybe<Scalars['JSON']>;
  css?: Maybe<Scalars['String']>;
  cssCode?: Maybe<Scalars['String']>;
  customFonts?: Maybe<Scalars['JSON']>;
  html?: Maybe<Scalars['String']>;
  httpRequests?: Maybe<Scalars['JSON']>;
  inputs?: Maybe<Scalars['JSON']>;
  jsCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
};

/** tiers for employee count */
export type EmployeeSize = {
  __typename?: 'EmployeeSize';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<EmployeeSizeData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type EmployeeSizeData = {
  __typename?: 'EmployeeSizeData';
  value?: Maybe<Scalars['JSON']>;
};

/** Frequently asked questions */
export type Faq = {
  __typename?: 'Faq';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<FaqData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type FaqData = {
  __typename?: 'FaqData';
  faq?: Maybe<Scalars['JSON']>;
};

/** CMS model for blog */
export type HiddenBlogs = {
  __typename?: 'HiddenBlogs';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<HiddenBlogsData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type HiddenBlogsData = {
  __typename?: 'HiddenBlogsData';
  author?: Maybe<Scalars['JSON']>;
  blurb?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  body2?: Maybe<Scalars['String']>;
  body3?: Maybe<Scalars['String']>;
  body4?: Maybe<Scalars['String']>;
  coverImage?: Maybe<Scalars['String']>;
  posterImage?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
};

/** Content copy for How Bambee Helps section */
export type HowBambeeHelps = {
  __typename?: 'HowBambeeHelps';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<HowBambeeHelpsData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type HowBambeeHelpsData = {
  __typename?: 'HowBambeeHelpsData';
  list?: Maybe<Scalars['JSON']>;
};

export type Page = {
  __typename?: 'Page';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<PageData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type PageData = {
  __typename?: 'PageData';
  blocks?: Maybe<Scalars['JSON']>;
  css?: Maybe<Scalars['String']>;
  cssCode?: Maybe<Scalars['String']>;
  customFonts?: Maybe<Scalars['JSON']>;
  /** SEO page description */
  description?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  httpRequests?: Maybe<Scalars['JSON']>;
  image?: Maybe<Scalars['String']>;
  inputs?: Maybe<Scalars['JSON']>;
  jsCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['JSON']>;
  /** SEO page title */
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  operator?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Fetch accordion-panel results */
  accordionPanel?: Maybe<Array<Maybe<AccordionPanel>>>;
  /** Fetch author results */
  author?: Maybe<Array<Maybe<Author>>>;
  /** Fetch blog results */
  blog?: Maybe<Array<Maybe<Blog>>>;
  /** Fetch categories results */
  categories?: Maybe<Array<Maybe<Categories>>>;
  /** Fetch component results */
  component?: Maybe<Array<Maybe<Component>>>;
  /** Fetch employee-size results */
  employeeSize?: Maybe<Array<Maybe<EmployeeSize>>>;
  /** Fetch faq results */
  faq?: Maybe<Array<Maybe<Faq>>>;
  /** Fetch hidden-blogs results */
  hiddenBlogs?: Maybe<Array<Maybe<HiddenBlogs>>>;
  /** Fetch how-bambee-helps results */
  howBambeeHelps?: Maybe<Array<Maybe<HowBambeeHelps>>>;
  /** Fetch just one accordion-panel */
  oneAccordionPanel?: Maybe<AccordionPanel>;
  /** Fetch just one author */
  oneAuthor?: Maybe<Author>;
  /** Fetch just one blog */
  oneBlog?: Maybe<Blog>;
  /** Fetch just one categories */
  oneCategories?: Maybe<Categories>;
  /** Fetch just one component */
  oneComponent?: Maybe<Component>;
  /** Fetch just one employee-size */
  oneEmployeeSize?: Maybe<EmployeeSize>;
  /** Fetch just one faq */
  oneFaq?: Maybe<Faq>;
  /** Fetch just one hidden-blogs */
  oneHiddenBlogs?: Maybe<HiddenBlogs>;
  /** Fetch just one how-bambee-helps */
  oneHowBambeeHelps?: Maybe<HowBambeeHelps>;
  /** Fetch just one page */
  onePage?: Maybe<Page>;
  /** Fetch just one site-theme */
  oneSiteTheme?: Maybe<SiteTheme>;
  /** Fetch just one sub-hero-icons */
  oneSubHeroIcons?: Maybe<SubHeroIcons>;
  /** Fetch just one symbol */
  oneSymbol?: Maybe<Symbol>;
  /** Fetch just one tags */
  oneTags?: Maybe<Tags>;
  /** Fetch just one test */
  oneTest?: Maybe<Test>;
  /** Fetch page results */
  page?: Maybe<Array<Maybe<Page>>>;
  /** Fetch site-theme results */
  siteTheme?: Maybe<Array<Maybe<SiteTheme>>>;
  /** Fetch sub-hero-icons results */
  subHeroIcons?: Maybe<Array<Maybe<SubHeroIcons>>>;
  /** Fetch symbol results */
  symbol?: Maybe<Array<Maybe<Symbol>>>;
  /** Fetch tags results */
  tags?: Maybe<Array<Maybe<Tags>>>;
  /** Fetch test results */
  test?: Maybe<Array<Maybe<Test>>>;
};


export type RootQueryTypeAccordionPanelArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeAuthorArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeBlogArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeComponentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeEmployeeSizeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeFaqArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeHiddenBlogsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeHowBambeeHelpsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneAccordionPanelArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneAuthorArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneBlogArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneCategoriesArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneComponentArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneEmployeeSizeArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneFaqArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneHiddenBlogsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneHowBambeeHelpsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOnePageArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneSiteThemeArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneSubHeroIconsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneSymbolArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneTagsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeOneTestArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypePageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeSiteThemeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeSubHeroIconsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeSymbolArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};


export type RootQueryTypeTestArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSONObject']>;
  query?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  target?: InputMaybe<Scalars['JSONObject']>;
};

/** Color Palette */
export type SiteTheme = {
  __typename?: 'SiteTheme';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<SiteThemeData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type SiteThemeData = {
  __typename?: 'SiteThemeData';
  black?: Maybe<Scalars['String']>;
  /** Do not use for text. */
  gray0?: Maybe<Scalars['String']>;
  /** Typically used for text on white or gray. */
  gray1?: Maybe<Scalars['String']>;
  gray2?: Maybe<Scalars['String']>;
  gray3?: Maybe<Scalars['String']>;
  gray4?: Maybe<Scalars['String']>;
  gray5?: Maybe<Scalars['String']>;
  gray6?: Maybe<Scalars['String']>;
  /** Typically used for light backgrounds. */
  gray7?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['String']>;
  primaryShade1?: Maybe<Scalars['String']>;
  primaryShade2?: Maybe<Scalars['String']>;
  primaryTint1?: Maybe<Scalars['String']>;
  primaryTint2?: Maybe<Scalars['String']>;
  primaryTint3?: Maybe<Scalars['String']>;
  primaryTint4?: Maybe<Scalars['String']>;
  primaryTint5?: Maybe<Scalars['String']>;
  primaryTint6?: Maybe<Scalars['String']>;
  secondary?: Maybe<Scalars['String']>;
  secondaryShade1?: Maybe<Scalars['String']>;
  secondaryShade2?: Maybe<Scalars['String']>;
  secondaryTint1?: Maybe<Scalars['String']>;
  secondaryTint2?: Maybe<Scalars['String']>;
  secondaryTint3?: Maybe<Scalars['String']>;
  secondaryTint4?: Maybe<Scalars['String']>;
  secondaryTint5?: Maybe<Scalars['String']>;
  white?: Maybe<Scalars['String']>;
};

/** Icons for the Subhero section on the homepage. */
export type SubHeroIcons = {
  __typename?: 'SubHeroIcons';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<SubHeroIconsData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type SubHeroIconsData = {
  __typename?: 'SubHeroIconsData';
  icons?: Maybe<Scalars['JSON']>;
};

export type Symbol = {
  __typename?: 'Symbol';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<SymbolData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type SymbolData = {
  __typename?: 'SymbolData';
  blocks?: Maybe<Scalars['JSON']>;
  css?: Maybe<Scalars['String']>;
  cssCode?: Maybe<Scalars['String']>;
  customFonts?: Maybe<Scalars['JSON']>;
  html?: Maybe<Scalars['String']>;
  httpRequests?: Maybe<Scalars['JSON']>;
  inputs?: Maybe<Scalars['JSON']>;
  jsCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
};

/** There are tags associated to blogs for easy searching. */
export type Tags = {
  __typename?: 'Tags';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<TagsData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type TagsData = {
  __typename?: 'TagsData';
  blog?: Maybe<Scalars['JSON']>;
  color?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
};

/** test thing */
export type Test = {
  __typename?: 'Test';
  content?: Maybe<Scalars['JSONObject']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Float']>;
  data?: Maybe<TestData>;
  endDate?: Maybe<Scalars['Float']>;
  everything?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['String']>;
  query?: Maybe<Array<Maybe<Query>>>;
  screenshot?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
  testRatio?: Maybe<Scalars['Int']>;
  variations?: Maybe<Scalars['JSONObject']>;
};

export type TestData = {
  __typename?: 'TestData';
  _none?: Maybe<Scalars['String']>;
};

export type GetBlogCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBlogCountQuery = { __typename?: 'RootQueryType', blog?: Array<{ __typename?: 'Blog', id?: string | null } | null> | null };

export type GetBlogsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetBlogsQuery = { __typename?: 'RootQueryType', blog?: Array<{ __typename?: 'Blog', id?: string | null, data?: { __typename?: 'BlogData', title?: string | null, posterImage?: string | null, author?: any | null, slug?: string | null, blurb?: string | null, tags?: any | null } | null } | null> | null };


export const GetBlogCountDocument = gql`
    query GetBlogCount {
  blog(options: {includeUnpublished: false, includeRefs: false}) {
    id
  }
}
    `;

/**
 * __useGetBlogCountQuery__
 *
 * To run a query within a Vue component, call `useGetBlogCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBlogCountQuery();
 */
export function useGetBlogCountQuery(options: VueApolloComposable.UseQueryOptions<GetBlogCountQuery, GetBlogCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBlogCountQuery, GetBlogCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBlogCountQuery, GetBlogCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBlogCountQuery, GetBlogCountQueryVariables>(GetBlogCountDocument, {}, options);
}
export type GetBlogCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBlogCountQuery, GetBlogCountQueryVariables>;
export const GetBlogsDocument = gql`
    query GetBlogs($offset: Int, $limit: Int) {
  blog(
    limit: $limit
    offset: $offset
    options: {includeUnpublished: false, includeRefs: true}
  ) {
    id
    data {
      title
      posterImage
      author
      slug
      blurb
      tags
    }
  }
}
    `;

/**
 * __useGetBlogsQuery__
 *
 * To run a query within a Vue component, call `useGetBlogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBlogsQuery({
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useGetBlogsQuery(variables: GetBlogsQueryVariables | VueCompositionApi.Ref<GetBlogsQueryVariables> | ReactiveFunction<GetBlogsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetBlogsQuery, GetBlogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBlogsQuery, GetBlogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBlogsQuery, GetBlogsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBlogsQuery, GetBlogsQueryVariables>(GetBlogsDocument, variables, options);
}
export type GetBlogsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBlogsQuery, GetBlogsQueryVariables>;
export const namedOperations = {
  Query: {
    GetBlogCount: 'GetBlogCount',
    GetBlogs: 'GetBlogs'
  }
}